export class Set {
    mainNumbers: number;
    luckyStars: number;

    constructor(mainNumbers: number, luckyStars: number) {
        this.mainNumbers = mainNumbers;
        this.luckyStars = luckyStars;
    }
}